import { __decorate } from "tslib";
import { AutoEncoder, field } from '@simonbackx/simple-encoding';
import { BaseOrganization } from '../Organization.js';
import { WebshopPreview } from './Webshop.js';
export class WebshopWithOrganization extends AutoEncoder {
    webshop = WebshopPreview.create({});
    organization = BaseOrganization.create({});
    /**
     * Proxy the webshop id so this object can be used in table/routing contexts
     * that require an id field (e.g. ModernTableView Route and useBackForward).
     */
    get id() {
        return this.webshop.id;
    }
    /**
     * Convenience getter for the webshop's full public URL (including https:// protocol).
     */
    get url() {
        return 'https://' + this.webshop.getUrl(this.organization);
    }
    /**
     * Returns the URL to the webshop management page in the dashboard.
     * Delegates to WebshopPreview.getDashboardUrl for deduplication.
     */
    get dashboardUrl() {
        return this.webshop.getDashboardUrl(this.organization);
    }
}
__decorate([
    field({ decoder: WebshopPreview })
], WebshopWithOrganization.prototype, "webshop", void 0);
__decorate([
    field({ decoder: BaseOrganization })
], WebshopWithOrganization.prototype, "organization", void 0);
//# sourceMappingURL=WebshopWithOrganization.js.map